import { createFetcher } from "api/helpers"

const fetcherConfig = {
  makeRequestUrl: (host, project) => {
    return `${host}/security/${project}/get_cloud_policy_scan_alert_counts`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined);
  },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfig)
